import { AppDispatch, RootState } from '@app/store';
import { useDispatch, TypedUseSelectorHook, useSelector } from 'react-redux';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const useAppDispatch = () => useDispatch<AppDispatch>();

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
